export default __webpack_public_path__ + "f5eafc996c77361cb92b6c2a45eddc63.png";